import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationIt from './locales/it/translation.json';
import translationEn from './locales/en/translation.json';
import translationFr from './locales/fr/translation.json';
import translationDe from './locales/de/translation.json';
import i18next from 'i18next';

const resources = {
    it: { translation: translationIt },
    en: { translation: translationEn },
    fr: { translation: translationFr },
    de: { translation: translationDe }
}

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'it',
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        }
    })

export default i18next